import Vue from 'vue'

export default {
  getPartners ({ commit }) {
    return Vue.axios.get('/partners')
    .then(({ data }) => commit('ADD_PARTNERS', data))
  },
  getPartner ({ commit }, id) {
    return Vue.axios.get(`/partners/${id}`)
    .then(({ data }) => commit('ADD_PARTNER', data))
  },
  addPartner ({ commit }, data) {
    return Vue.axios.post(`/partners`, data)
    .then(({ data }) => commit('ADD_NEW_PARTNER', data))
  },
  updatePartner ({ commit }, data) {
    return Vue.axios.put(`/partners`, data)
    .then(({ data }) => commit('UPDATE_PARTNER', data))
  },
  deletePartner ({ commit }, id) {
    return Vue.axios.delete(`/partners/${id}`)
    .then(() => commit('DELETE_PARTNER', id))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/partners.js